import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useSestCodeToName from '@di-shared/features/diag/sest/useSestCodeToName';
import {CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

interface NoticeStepProps {
  onNext: () => void;
  exchangeDate: Date | null;
  exchangeSestCodes: CreatedMaintenanceRecordRequest.sestCode[];
}

function SestExchangeHistoryNotice({onNext, exchangeDate, exchangeSestCodes}: NoticeStepProps) {
  const {t} = useInferableTranslation();
  const {convertSestCodesToNames} = useSestCodeToName();
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  const exchangeSestNames = convertSestCodesToNames(exchangeSestCodes);
  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T30292')}</h2>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong
            className="bottom_sheet_title_sub"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T30293')}
          </strong>

          <div className="exchange_expendable">
            <strong className="bottom_sheet_title_sub">{t('T30294')}</strong>
            <p className="bottom_sheet_text">{exchangeDate && CldrDatetimeFormatter.format(exchangeDate, 'yMMMd')}</p>
            <p className="bottom_sheet_text">{exchangeSestNames.join(', ')}</p>
          </div>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={onNext}
          >
            {t('T10114')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SestExchangeHistoryNotice;
